/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAccess } from './customer_access'
/**
 * Данные контрагента
 */
export type CustomerItem = {
  /**
   * Идентификатор контрагента
   */
  id: string
  /**
   * Тип контрагента
   */
  type: CustomerItem.type
  /**
   * Наименование
   */
  name: string
  /**
   * ИНН
   */
  inn: string
  /**
   * КПП
   */
  kpp?: string
  /**
   * Юридический адрес
   */
  legalAddress?: string
  /**
   * Доступны ли контрагенту старые ВГХ при оформлении груза
   */
  hasSpecialCargoLimits: boolean
  /**
   * Права доступа
   */
  access: CustomerAccess
}
export namespace CustomerItem {
  /**
   * Тип контрагента
   */
  export enum type {
    LEGAL = 'legal'
  }
}
